import React from 'react'

const OrderHelp = () => {
    return (
        <div className="tab-content_data">
            <h3>Hi, let us help you with your queries</h3>
            <div className="help_btn-sectoin">
                <button type="button" className="common_btn view-data-btn help_btn_spc">
                    WHATS APP
                </button>
                <button type="button" className="common_btn btn-primary-bth help_btn_spc">
                    CALL US
                </button>
                <button type="button" className="common_btn chat_bot_btn">
                    CHAT BOT
                </button>
            </div>
        </div>
    )
}

export default OrderHelp
